export const pageState = {
    IMPORTMODEL: { value: 1, label: 'Import model' },
    EXPORTPAGE: { value: 2, label: 'Export page' },
    ISSUELIST: { value: 3, label: 'Issue list' },
    DETAILISSUE: { value: 4, label: 'Detail issue' },
    EDITISSUE: { value: 5, label: 'Edit issue' },
    FILTERISSUE: { value: 6, label: 'Filter issue' },
    PROCESS: { value: 7, label: 'Process' }
}